import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Email from 'react-sharingbuttons/dist/buttons/Email';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Button, Input, InputGroup } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp as fabFaWhatsapp } from '@fortawesome/free-brands-svg-icons';

import env from 'Env';

import 'Components/Order/RedeemGiftShare.scss';

const RedeemGiftShare = ({ code }) => {
  const [copied, setCopied] = useState(false);

  const frontendLink = env.appUrl || '';
  let link = `https://${frontendLink}/${window.locale || 'en'}/redeem-gift?giftcode=${code}`;

  if (frontendLink.includes('localhost')) {
    link = `${frontendLink}/${window.locale || 'en'}/redeem-gift?giftcode=${code}`;
  }

  return (
    <div className="redeem-gift-share">
      <div className="redeem-gift-share-section-title">
        <FormattedMessage id=".redeemgiftshare.giftredeemlink" defaultMessage="Recipient Gift Redeem Link" />
      </div>

      <div className="redeem-gift-share-form">
        <InputGroup>
          <Input
            readOnly
            aria-label="gift-share-link"
            type="text"
            value={link}
            className={'key-input-field'}
          />
          <div className="input-group-append">
            <CopyToClipboard text={link} onCopy={() => setCopied(true)}>
              <Button color="primary"><FormattedMessage id="redeemgiftshare.copy" defaultMessage="Copy Link" /></Button>
            </CopyToClipboard>
          </div>
        </InputGroup>
        <div className="referral-copy-button-mobile">
          <CopyToClipboard text={link} onCopy={() => setCopied(true)}>
            <Button color="primary"><FormattedMessage id="redeemgiftshare.copy" defaultMessage="Copy Link" /></Button>
          </CopyToClipboard>
        </div>
      </div>

      {copied &&
        <div className="copied-text">
          <FormattedMessage id="redeemgiftshare.copied" defaultMessage="Your recipient's gift redeem link has been copied." />
        </div>
      }

      <div className="redeem-gift-share-section-title mt-4">
        <FormattedMessage
          id="redeemgiftshare.title.share-link"
          defaultMessage="Share your link"
        />
      </div>

      <div className="refer-share-buttons">
        <div className="refer-share-buttton">
          <Email url={link} text="Join me on Fanatical" subject="Join me on Fanatical" />
        </div>
        <div className="refer-share-buttton">
          <a
            href={`https://wa.me/?text=${link}`}
            target="_blank"
            rel="noopener noreferrer"
            className="react-sharing-button__link whatsapp"
          >
            <FontAwesomeIcon icon={fabFaWhatsapp} size="lg" />
          </a>
        </div>
        <div className="refer-share-buttton">
          <CopyToClipboard text={link} onCopy={() => setCopied(true)}>
            <button className="btn btn-primary react-sharing-button__link email">
              <FontAwesomeIcon icon={faLink} color="white" />
            </button>
          </CopyToClipboard>
        </div>
      </div>
    </div>
  );
};

RedeemGiftShare.propTypes = {
  code: PropTypes.string.isRequired,
};


export default RedeemGiftShare;
